import { CloseSquare } from "iconsax-react";
import { useEffect, useState } from "react";
// import PatientInfoTab from "./tabs/PatientInfoTab";
// import PatientOrderTab from "./tabs/PatientOrderTab";
import { getToken } from "../../utils/token";
import instance from "../../axios/instance";
import NormalInputField from "../inputs/NormalInputField";
import NormalSelectInputField from "../inputs/NormalSelectInputField";
import Spinner from "../spinners/Spinner";
import { useNavigate } from "react-router-dom";
import countries from "../../../countries.json";
import { ethnicities } from "../../utils/data";
import { convertLocaleStringToDateInputValue } from "../../utils/calculateAge";
import { Autocomplete, TextField } from "@mui/material";
import { PhoneInputField } from "../inputs/PhoneInputField";
// import PatientModal from "./PatientModal";

export default function EditPatientModal(props) {
  const token = getToken();
  const navigate = useNavigate();

  // loading state
  const [isLoading, setIsLoading] = useState(false);
  // error state
  const [errorMessage, setErrorMessage] = useState("");

  const data = props.patient;
  // form states
  const [firstname, setFirstname] = useState(data.firstname || "");
  const [middleName, setMiddleName] = useState(data.middlename || "");
  const [lastname, setLastname] = useState(data.lastname || "");
  const [dob, setDob] = useState(
    convertLocaleStringToDateInputValue(data.dob) || ""
  );
  const [birthSex, setBirthSex] = useState(data.birth_sex || "");
  const [gender, setGender] = useState(data.gender || "");
  const [nickname, setNickname] = useState(data.nickname || "");
  const [maidenName, setMaidenName] = useState(data.maiden_name || "");

  const [address1, setAddress1] = useState(data.address1 || "");
  const [address2, setAddress2] = useState(data.address2 || "");
  const [country, setCountry] = useState(data.country || "");
  const [state, setState] = useState(data.state || "");
  const [city, setCity] = useState(data.city || "");
  const [zipcode, setZipcode] = useState(data.zipcode || "");
  const [cellPhone, setCellPhone] = useState(data.cell_phone || "");
  const [homePhone, setHomePhone] = useState(data.home_phone || "");
  const [workPhone, setWorkPhone] = useState(data.work_phone || "");
  const [email, setEmail] = useState(data.email_address || "");

  const [language, setLanguage] = useState(data.language || "");
  const [race, setRace] = useState(data.race || "");
  const [ethnicity, setEthnicity] = useState(data.ethnicity || "");
  const [smokingStatus, setSmokingStatus] = useState(data.smoking_status || "");
  const [drugAllergies, setDrugAllergies] = useState(data.drug_allergies || "");
  const [bloodGroup, setBloodGroup] = useState(data.blood_group || "");
  const [maritalStatus, setMaritalStatus] = useState(data.marital_status || "");
  const [employmentStatus, setEmploymentStatus] = useState(
    data.employment_status || ""
  );
  const [doctors, setDoctors] = useState([]);
  const [supervisingPractitioner, setSupervisingPractitioner] = useState({
    label: data.supervising_practitioner_id,
    value: data.supervising_practitioner_id,
  });
  const [notifyPatient, setNotifyPatient] = useState(
    data.notify_patient === "true"
  );

  const disabled = data.account_status === "active";

  const isButtonNotActive = disabled
    ? !supervisingPractitioner?.value
    : !firstname ||
      !lastname ||
      !dob ||
      !birthSex ||
      !address1 ||
      !country ||
      !state ||
      !city ||
      !zipcode ||
      !cellPhone ||
      !email;

  async function addPatient() {
    setErrorMessage("");
    setIsLoading(true);
    instance
      .put(
        "/doctor/patient/edit",
        {
          firstname: firstname,
          middlename: middleName,
          lastname: lastname,
          dob: new Date(dob).toLocaleString(),
          birth_sex: birthSex,
          gender_identity: gender,
          nickname: nickname,
          maiden_name: maidenName,
          address1: address1,
          address2: address2,
          country: country,
          state: state,
          city: city,
          zipcode: zipcode,
          cell_phone: cellPhone,
          home_phone: homePhone,
          work_phone: workPhone,
          email: email,
          language: language,
          race: race,
          ethnicity: ethnicity,
          smoking_status: smokingStatus,
          blood_group: bloodGroup,
          drug_allergies: drugAllergies,
          marital_status: maritalStatus,
          employment_status: employmentStatus,
          id: data.id,
          supervising_practitioner_id: supervisingPractitioner?.value,
          notifyPatient: `${notifyPatient}`,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setIsLoading(false);
        props.triggerRevalidate(response.data);
        props.onClose();
      })
      .catch((error) => {
        console.log(error.response.data);
        setErrorMessage(error.response.data.message);
        setIsLoading(false);
      });
  }

  // useEffect(() => {
  //  setIsLoading(false)
  // }, [supervisingPractitioner, data]);

  useEffect(() => {
    let loaded = true;
    (async () => {
      try {
        const doctors = await instance.get("/doctor/facility/doctors", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (loaded) {
          if (doctors.data.length >= 1) {
            setDoctors(
              doctors.data
                .filter((doc) => doc.account_status === "active")
                .map((doctor) => ({
                  label: `${doctor.lastname} ${doctor.firstname}`,
                  value: doctor.id,
                }))
            );
            if (data.supervising_practitioner_id) {
              const doc = doctors.data.find(
                (doc) => doc.id === data.supervising_practitioner_id
              );
              doc &&
                setSupervisingPractitioner((_) => ({
                  ..._,
                  label: `${doc.lastname} ${doc.firstname}`,
                }));
            }
          } else {
            setDoctors([]);
          }
        }
      } catch (e) {
        setErrorMessage("Failed to fetch doctors, please reload page");
        console.log(e);
      }
    })();

    return () => {
      loaded = false;
    };
  }, []);

  return (
    <div
      className={`block fixed top-0 right-0 left-0 bottom-0 z-50 bg-white overflow-y-scroll scrollbar-hide`}
    >
      <div className="sticky left-0 right-0 top-0">
        <div className="bg-[#f1f1f1] px-5 py-4 flex justify-between">
          <div className="text-[18px] font-bold select-none">
            Edit Patient - #{data.id}
          </div>
          <button onClick={props.onClose}>
            <CloseSquare variant="Bold" />
          </button>
        </div>
      </div>

      <div className="text-[14px] grid grid-cols-[auto_35%] gap-x-5 mt-5">
        <div className="px-5 pr-0 py-3 space-y-6">
          <div>
            <div className="font-bold text-[16px]">Basic Information</div>

            <div className="mt-4 space-y-4">
              <div className="grid grid-cols-2 gap-x-4 gap-y-4 items-center">
                <NormalInputField
                  title="First name"
                  isRequired={true}
                  type="text"
                  onChange={(e) => setFirstname(e.target.value)}
                  value={firstname}
                  disabled={disabled}
                />

                <NormalInputField
                  title="Middle name"
                  type="text"
                  onChange={(e) => setMiddleName(e.target.value)}
                  value={middleName}
                  disabled={disabled}
                />
              </div>

              <div className="grid grid-cols-2 gap-x-4 gap-y-4 items-center">
                <NormalInputField
                  title="Last name"
                  isRequired={true}
                  type="text"
                  onChange={(e) => setLastname(e.target.value)}
                  value={lastname}
                  disabled={disabled}
                />

                <NormalInputField
                  title="D.O.B"
                  isRequired={true}
                  type="date"
                  onChange={(e) => setDob(e.target.value)}
                  value={dob}
                  disabled={disabled}
                />
              </div>

              <div className="grid grid-cols-2 gap-x-4 gap-y-4 items-center">
                <NormalSelectInputField
                  title="Birth Sex"
                  isRequired={true}
                  values={["Male", "Female"]}
                  onChange={(e) => setBirthSex(e.target.value)}
                  value={birthSex}
                  disabled={disabled}
                />

                <NormalSelectInputField
                  title="Gender Identity"
                  values={["Male", "Female", "Rather not say"]}
                  onChange={(e) => setGender(e.target.value)}
                  value={gender}
                  disabled={disabled}
                />
              </div>

              <div className="grid grid-cols-2 gap-x-4 gap-y-4 items-center">
                <NormalInputField
                  title="Nickname"
                  type="text"
                  onChange={(e) => setNickname(e.target.value)}
                  value={nickname}
                  disabled={disabled}
                />

                <NormalInputField
                  title="Maiden Name"
                  type="text"
                  onChange={(e) => setMaidenName(e.target.value)}
                  value={maidenName}
                  disabled={disabled}
                />
              </div>
            </div>
          </div>

          <div>
            <div className="font-bold text-[16px]">Contact Details</div>

            <div className="mt-4 space-y-4">
              <div className="grid grid-cols-2 gap-x-4 gap-y-4 items-center">
                <NormalInputField
                  title="Address Line 1"
                  isRequired={true}
                  type="text"
                  onChange={(e) => setAddress1(e.target.value)}
                  value={address1}
                  disabled={disabled}
                />

                <NormalInputField
                  title="Address Line 2"
                  type="text"
                  onChange={(e) => setAddress2(e.target.value)}
                  value={address2}
                  disabled={disabled}
                />
              </div>

              <div className="grid grid-cols-2 gap-x-4 gap-y-4 items-center">
                <NormalSelectInputField
                  title="Country"
                  isRequired={true}
                  values={countries.map((country) => country.name)}
                  onChange={(e) => setCountry(e.target.value)}
                  value={country}
                  disabled={disabled}
                />

                <NormalSelectInputField
                  title="State"
                  isRequired={true}
                  values={
                    country
                      ? countries
                          .find(
                            (_country) =>
                              _country.name.toLowerCase() ===
                              country.toLowerCase()
                          )
                          .states.map((state) => state.name)
                      : []
                  }
                  onChange={(e) => setState(e.target.value)}
                  value={state}
                  disabled={disabled}
                />
              </div>

              <div className="grid grid-cols-2 gap-x-4 gap-y-4 items-center">
                <NormalInputField
                  title="City"
                  type="text"
                  isRequired={true}
                  onChange={(e) => setCity(e.target.value)}
                  value={city}
                  disabled={disabled}
                />

                <NormalInputField
                  title="Zip Code"
                  isRequired={true}
                  type="text"
                  onChange={(e) => setZipcode(e.target.value)}
                  value={zipcode}
                  disabled={disabled}
                />
              </div>

              <div className="grid grid-cols-2 gap-x-4 gap-y-4 items-center">
                <PhoneInputField
                  title={"Cell Phone"}
                  isRequired={true}
                  onChange={setCellPhone}
                  value={cellPhone}
                  country={country}
                  disabled={disabled}
                />
                <PhoneInputField
                  title={"Home Phone"}
                  isRequired={false}
                  onChange={setHomePhone}
                  value={homePhone}
                  country={country}
                  disabled={disabled}
                />
              </div>

              <div className="grid grid-cols-2 gap-x-4 gap-y-4 items-center">
                <PhoneInputField
                  title={"Work Phone"}
                  isRequired={false}
                  onChange={setWorkPhone}
                  value={workPhone}
                  country={country}
                  disabled={disabled}
                />

                <NormalInputField
                  title="Email Address"
                  type="email"
                  isRequired={true}
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  disabled={disabled}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="border-l px-4 py-3">
          <div>
            <div className="font-bold text-[16px]">Additional Information</div>

            <div className="mt-4 space-y-4">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={doctors}
                onChange={(e, val) => setSupervisingPractitioner(val)}
                value={supervisingPractitioner}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select supervising practitioner"
                    required={true}
                  />
                )}
                size="small"
              />
              <NormalSelectInputField
                title="Language"
                values={["English", "German"]}
                onChange={(e) => setLanguage(e.target.value)}
                value={language}
                disabled={disabled}
              />

              <NormalSelectInputField
                title="Race"
                values={["Black", "Asian", "White", "Other"]}
                onChange={(e) => setRace(e.target.value)}
                value={race}
                disabled={disabled}
              />

              <NormalSelectInputField
                title="Ethnicity"
                values={ethnicities}
                onChange={(e) => setEthnicity(e.target.value)}
                value={ethnicity}
                disabled={disabled}
              />

              <NormalSelectInputField
                title="Smoking Status"
                values={["Still smokes", "Does not Smoke", "Addict"]}
                onChange={(e) => setSmokingStatus(e.target.value)}
                value={smokingStatus}
                disabled={disabled}
              />

              <NormalSelectInputField
                title="Blood Group"
                values={["A", "B", "AB", "O+", "O-"]}
                onChange={(e) => setBloodGroup(e.target.value)}
                value={bloodGroup}
                disabled={disabled}
              />

              <NormalInputField
                title="Drug Allergies"
                type="text"
                onChange={(e) => setDrugAllergies(e.target.value)}
                value={drugAllergies}
                disabled={disabled}
              />

              <NormalSelectInputField
                title="Maritial Status"
                values={["Married", "Single"]}
                onChange={(e) => setMaritalStatus(e.target.value)}
                value={maritalStatus}
                disabled={disabled}
              />

              <NormalSelectInputField
                title="Employment Status"
                values={["Employed", "Unemployed"]}
                onChange={(e) => setEmploymentStatus(e.target.value)}
                value={employmentStatus}
                disabled={disabled}
              />
              <div className="!mt-5 flex items-center gap-y-2 gap-x-1.5">
                <input
                  type="checkbox"
                  id="notifyPatient"
                  name="notifyPatient"
                  defaultChecked={notifyPatient}
                  value={notifyPatient}
                  onChange={(e) => setNotifyPatient(e.target.checked)}
                />
                <label
                  htmlFor="notifyPatient"
                  className="font-semibold uppercase text-gray-600"
                >
                  Notify Patient
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-3 border-t">
        <div className="font-semibold text-[tomato] text-right text-[14px] py-1">
          {errorMessage}
        </div>
        <div className="flex justify-between gap-2 items-center">
          <button
            onClick={props.onClose}
            className={`cursor-pointer bg-[tomato] text-white min-w-[200px] py-3 px-3 shadow-sm rounded-[4px] font-semibold text-[14px]`}
          >
            Close
          </button>
          <PrimaryAddButton
            onClick={addPatient}
            isLoading={isLoading}
            disabled={isButtonNotActive || isLoading}
          />
        </div>
      </div>
    </div>
  );
}

function PrimaryAddButton(props) {
  return (
    <button
      disabled={props.disabled}
      onClick={props.onClick}
      className={`cursor-pointer bg-primary text-white disabled:cursor-not-allowed disabled:opacity-50 min-w-[200px] flex justify-center items-center py-3 px-3 shadow-sm rounded-[4px] font-semibold text-[14px]`}
    >
      {props.isLoading ? (
        <span className="px-10 block">
          <Spinner color="white" />
        </span>
      ) : (
        "Save Patient"
      )}
    </button>
  );
}
